import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const OptionContainer = styled.div<{
  $isRenderedInContextualFieldMenu?: boolean;
  isSelected: boolean;
}>`
  display: grid;
  grid-template: 'icon title' 'icon meta' / auto 1fr;
  padding-block: ${(props) =>
    props.$isRenderedInContextualFieldMenu ? token('space.050') : token('space.0')};

  > :nth-child(1) {
    grid-area: icon;
    padding: ${token('space.050')} ${token('space.100')} 0 0;
  }

  > :nth-child(2) {
    grid-area: title;
  }

  > :nth-child(3) {
    grid-area: meta;
    color: ${(props) =>
      props.isSelected ? 'inherit' : token('color.text.subtle', '#44546F')};
    font: ${token('font.body.small')};
  }
`;
